export const MISSIONDATA = [
    "올해 계획에 없었지만 뜻밖에 즐거웠던 일이나, 예상 밖으로 나를 웃게 만든 작은 순간은 뭐였어? 산타에게 슬쩍 얘기해줘! 🎁",
    "산타가 모르는 나의 비밀스러운 취향 하나를 알려줘! 내 친구들이 이걸 맞출 수 있을까? 진짜 내 친구라면, 이 취향까지 알겠지? 😏",
    "올해 힘들었지만 그만큼 성숙해졌다고 느낀 순간이 있다면? 산타에게 그 경험을 나눠줘! 너의 한 해를 산타가 진심으로 축하해 줄게. 🎉",
    "내가 보낸 메시지 중 가장 반응이 좋았거나, 나 스스로 너무 웃겼던 거 하나만 공유해줘! 그 순간을 생각하면서 같이 웃어보자. 😂",
    "내년의 나에게 하고 싶은 약속이나 꼭 이루고 싶은 목표가 있어? 산타가 네 목표를 기억하고 응원해 줄게. 🎯",
    "기쁘거나 슬퍼서 울컥했던, 가슴이 뭉클해진 순간을 나눠줘. 우리 같이 올해의 감동을 떠올려 보자. 🥲",
    "크리스마스를 맞이해, 내가 진심으로 이루고 싶은 소망을 하나만 살짝 털어놓기! 크리스마스 기적이 이뤄질지도 몰라... 🎄",
    "내 올해를 한 줄로 요약한다면 뭐라고 표현할 수 있을까? 유머든 진지하든 좋으니, 내 한 해를 산타에게 압축해서 알려줘!",
    "올해 나를 위해 찾은 최고의 간식 조합이 있다면? 산타가 나중에 한 번 따라 해보게 살짝 비법을 알려줘! 🍟🍦",
    "올해 너의 웃음이 멈추지 않게 만든 일이 있다면? 산타가 상상하면서 피식 웃을 준비 완료! 😜",
  ];

  export const LETTERIMAGES = [
    "/image/letterImg/Letter1.png",
    "/image/letterImg/Letter2.png",
    "/image/letterImg/Letter3.png",
    "/image/letterImg/Letter4.png",
    "/image/letterImg/Letter5.png",
    "/image/letterImg/Letter6.png",
  ];
  